import React from 'react';
import { connect } from 'react-redux';

export function Stories(props) {
  return <pre>
    <code>
      {JSON.stringify(props, null, 2)}
    </code>
  </pre>;
}

export default connect((state) => state)(Stories);



// WEBPACK FOOTER //
// ./src/components/Stories.js